(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/hooks/use-customer-properties.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/hooks/use-customer-properties.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const communicationSettingsService = svs.myProfile.react.pages.communicationSettings.communicationSettings.communicationSettingsService;

const useCustomerProperties = (setPlayerPropertiesData, setShouldShowApiError) => {
  const _useState = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)),
    _useState2 = _slicedToArray(_useState, 1),
    isPlayerLoggedIn = _useState2[0];
  useEffect(() => {
    const getCustomerDataEmailMobile = async () => {
      try {
        svs.myProfile.logger.debug('Fetch Customers Properties data from backend...');
        const _await$communicationS = await communicationSettingsService.getCustomersPropertiesAsync(),
          playerProperties = _await$communicationS.playerProperties;
        setPlayerPropertiesData(playerProperties);
        svs.myProfile.logger.debug('Fetch Customers Properties data from backend... success');
      } catch (error) {
        svs.myProfile.logger.error('CommunicationSettings: catch: Fetch Customers Properties error...', error);
        setShouldShowApiError(true);
      }
    };
    if (isPlayerLoggedIn) {
      getCustomerDataEmailMobile();
    }
  }, []);
};
useCustomerProperties.propTypes = {
  setPlayerPropertiesData: PropTypes.func.isRequired,
  setShouldShowApiError: PropTypes.func.isRequired
};
svs.myProfile.react.pages.communicationSettings.communicationSettings.hooks.useCustomerProperties = useCustomerProperties;

 })(window);